import type { Ref } from 'vue'
import { api } from '@/api'

/**
 * 滚动管理 Composable
 * 负责滚动位置的上报和完读判断
 */

interface ChapterScrollOptions {
  contentId: Ref<string>
  chapterId: Ref<string>
  chapter: Ref<any>
  chapterList: Ref<any[]>
  containerRef: Ref<HTMLElement | undefined>
  chapterRef: Ref<HTMLElement | undefined>
  y: Ref<number>
  readCompleteTrack: (contentId: string, chapterId: string, sequenceNo: number, chapterVersionId: string) => void
}

export function useChapterScroll(options: ChapterScrollOptions) {
  const {
    contentId,
    chapterId,
    chapter,
    chapterList,
    containerRef,
    chapterRef,
    y,
    readCompleteTrack,
  } = options

  /**
   * 上报滚动位置
   */
  async function reportScrollLocation(scrollY: number = 0) {
    try {
      await api.post<any, PostReadReportResponse>('/read/report', {
        contentId: contentId.value,
        chapterId: chapterId.value,
        chapterVersionId: chapter.value?.chapterVersionId,
        sectionMediaPlayedSeconds: Math.floor(scrollY),
        videoDuration: containerRef.value ? (containerRef.value.scrollHeight - containerRef.value.clientHeight) : 0,
      })
    }
    catch {
      // 静默失败
    }
  }

  /**
   * 完读判断和上报
   */
  function handleReadComplete() {
    const height = chapterRef.value?.offsetHeight || 0
    const clientHeight = containerRef.value?.clientHeight || 0
    const chapterItem = chapterList.value.find((item: any) => item.id === chapterId.value)
    const distance = height - y.value - clientHeight

    // 距离底部小于 100px 时,判定为完读
    // 完读上报, 大数据会去重, 所以同一章报两次可以接受
    if (chapterItem && chapterItem.lockStatus !== 1 && distance < 100)
      readCompleteTrack(contentId.value, chapterId.value, chapterItem.sequenceNo, chapterItem.chapterVersionId)
  }

  return {
    reportScrollLocation,
    handleReadComplete,
  }
}
